import PropTypes from 'prop-types';
export default PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  className: PropTypes.string.isRequired,
  replaceBaseClass: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  cssModule: PropTypes.object,
  retainMissingModuleClasses: PropTypes.bool
})]);